import React, { useEffect } from 'react';

export default function Shipping() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-20 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-[2rem] p-8 md:p-12 shadow-sm border border-slate-100">
          <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-8">Shipping Policy</h1>
          
          <div className="space-y-6 text-slate-600 leading-relaxed">
            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Processing Time</h2>
            <p>
              Once your prescription is approved by a licensed healthcare provider, orders are typically processed by the pharmacy within 1-2 business days. Processing times may vary depending on medication availability and pharmacy volume.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Shipping Methods & Costs</h2>
            <p>
              We offer standard shipping on all medication orders. Shipping is included in the cost of your treatment plan unless otherwise specified during checkout. Packages are shipped discreetly to protect your privacy.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Delivery Times</h2>
            <p>
              Standard delivery typically takes 2-4 business days from the date the pharmacy processes and ships the order. Expedited shipping options may be available for an additional fee depending on your location and the medication prescribed.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">Temperature-Sensitive Medications</h2>
            <p>
              Certain medications require refrigeration. These items are shipped with specialized cold packs and expedited shipping to ensure they remain at the proper temperature during transit. It is your responsibility to refrigerate these medications immediately upon delivery.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">State Restrictions</h2>
            <p>
              Due to state laws and pharmacy regulations, some medications cannot be shipped to certain states (e.g., Louisiana, Mississippi, Puerto Rico). Please refer to the specific medication's availability on our Treatments page.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}